/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationWarranty200Response
 */
export interface GetReservationWarranty200Response {
    /**
     * 
     * @type {string}
     * @memberof GetReservationWarranty200Response
     */
    type: GetReservationWarranty200ResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetReservationWarranty200Response
     */
    method?: GetReservationWarranty200ResponseMethodEnum;
    /**
     * 
     * @type {number}
     * @memberof GetReservationWarranty200Response
     */
    amount?: number;
}


/**
 * @export
 */
export const GetReservationWarranty200ResponseTypeEnum = {
    Card: 'CARD',
    Deposit: 'DEPOSIT',
    None: 'NONE'
} as const;
export type GetReservationWarranty200ResponseTypeEnum = typeof GetReservationWarranty200ResponseTypeEnum[keyof typeof GetReservationWarranty200ResponseTypeEnum];

/**
 * @export
 */
export const GetReservationWarranty200ResponseMethodEnum = {
    All: 'ALL',
    LargeGroups: 'LARGE-GROUPS',
    ByPerson: 'BY-PERSON'
} as const;
export type GetReservationWarranty200ResponseMethodEnum = typeof GetReservationWarranty200ResponseMethodEnum[keyof typeof GetReservationWarranty200ResponseMethodEnum];


/**
 * Check if a given object implements the GetReservationWarranty200Response interface.
 */
export function instanceOfGetReservationWarranty200Response(value: object): value is GetReservationWarranty200Response {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function GetReservationWarranty200ResponseFromJSON(json: any): GetReservationWarranty200Response {
    return GetReservationWarranty200ResponseFromJSONTyped(json, false);
}

export function GetReservationWarranty200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationWarranty200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'method': json['method'] == null ? undefined : json['method'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function GetReservationWarranty200ResponseToJSON(json: any): GetReservationWarranty200Response {
    return GetReservationWarranty200ResponseToJSONTyped(json, false);
}

export function GetReservationWarranty200ResponseToJSONTyped(value?: GetReservationWarranty200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'method': value['method'],
        'amount': value['amount'],
    };
}

